import type { MuiTheme as Theme } from '@paintscout/ui'

export default (theme: Theme, width?: 'xl' | '') => {
  const styles = {
    [theme.breakpoints.down('sm')]: {
      width: '90%'
    },
    maxWidth: width === 'xl' ? `95%` : `1440px`,
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto'
  }

  return styles
}
